
import React from 'react';
import {
    makeStyles,
    Card,
    CardContent,
    CardActionArea,
    Typography,
    IconButton,
    Menu,
    MenuItem,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Crime from '../model/Crime';

const useStyles = makeStyles(theme => ({
    card: {
        flexGrow: 1,
        display: 'flex'
    },
    wrapedText: {
        flex: 1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: '40px',
    },
    menuBtn: {
        maxWidth: '200px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: '40px',
    },
}));

type CrimeCardProps = {
    crime: Crime,
    onEdit: (uuid: string) => void,
    onDelete: (uuid: string) => void,
    onCopy: (uuid: string) => void
}
const CrimeCard: React.FC<CrimeCardProps> = (props) => {
    const [anchorEl, setAnchorEl] = React.useState<any>(null);
    const classes = useStyles();
    const crime = props.crime;

    return (


        <Card className={classes.card}  >

            <CardActionArea onClick={() => props.onEdit(crime.uuid)} className={classes.wrapedText}>
                <CardContent >
                    <Typography noWrap variant="body1" color="textPrimary">
                        {crime.objectName}
                    </Typography>
                    <Typography noWrap variant="body2" color="textSecondary">
                        {crime.crimeDescription}
                    </Typography>
                </CardContent>
            </CardActionArea>

            <IconButton className={classes.menuBtn} onClick={(event) =>
                setAnchorEl(event.currentTarget)
            }><MoreVertIcon /></IconButton>
            <Menu id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}>
                <MenuItem onClick={() => {
                    props.onCopy(crime.uuid);
                    setAnchorEl(null);
                }}>Копировать</MenuItem>
                <MenuItem onClick={() => {
                    props.onDelete(crime.uuid);
                    setAnchorEl(null);
                }}>Удалить</MenuItem>
            </Menu>
        </Card >

    );
}

export default CrimeCard;